import { createSlice } from "@reduxjs/toolkit";
import { 
  getCompanyProfile, 
  updateCompanyProfile,
} from "../thunks/companyThunks";

const initialState = {
  // Client-side company profile management
  companyProfile: {
    data: null,
    loading: false,
    error: null,
  },
};

const companySlice = createSlice({
  name: "company",
  initialState,

  extraReducers: (builder) => {
    // ------------------- CLIENT COMPANY PROFILE MANAGEMENT -------------------
    // Get Company Profile
    builder
      .addCase(getCompanyProfile.pending, (state) => {
        state.companyProfile.loading = true;
        state.companyProfile.error = null;
      })
      .addCase(getCompanyProfile.fulfilled, (state, action) => {
        state.companyProfile.loading = false;
        state.companyProfile.data = action.payload.data;
      })
      .addCase(getCompanyProfile.rejected, (state, action) => {
        state.companyProfile.loading = false;
        state.companyProfile.error = action.payload || "Failed to fetch company profile";
        state.companyProfile.data = null;
      });

    // Update Company Profile
    builder
      .addCase(updateCompanyProfile.pending, (state) => {
        state.companyProfile.loading = true;
        state.companyProfile.error = null;
      })
      .addCase(updateCompanyProfile.fulfilled, (state, action) => {
        state.companyProfile.loading = false;
        state.companyProfile.data = action.payload.data;
      })
      .addCase(updateCompanyProfile.rejected, (state, action) => {
        state.companyProfile.loading = false;
        state.companyProfile.error = action.payload || "Failed to update company profile";
      });
  },
});

// Export reducer
export default companySlice.reducer;